// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1dPQR","list":"styles_list__BJWfw"};